import { configureStore } from 'redux-starter-kit';
import rootReducer from './reducers';

// prettier-ignore
export default (preloadedState = {}) =>
  configureStore({ reducer: rootReducer, preloadedState });
